'use client'

import { SectionHeader } from '@/components/section-header'
import { TallyForm } from '@/components/tally-form'

export const ContactSection = () => {
  return (
    <section id="contact" className="w-full py-8 lg:py-16 px-4 lg:px-[240px]" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="max-w-[1440px] mx-auto">
        {/* ヘッダー部分 */}
        <div className="mb-8">
          <SectionHeader title="お問い合わせ・資料請求" />
        </div>

        {/* フォーム表示エリア */}
        <TallyForm />
      </div>
    </section>
  )
}
